<template>
  <div v-if="unverifiedEmails.length" class="unverified-emails">
    <p>
      <translate tag="strong"> Verify your Pitchup.com account... </translate>
      <br />
      <translate> Please check your email for your confirmation. </translate>
    </p>
    <div
      v-for="email of unverifiedEmails"
      :key="email.email"
      class="row unverified"
    >
      <span class="email">{{ email.email }}</span>
      <base-button
        v-if="!email.isConfirmationSent"
        css-class="outline minimal tiny"
        @click="$emit('resend', email.email)"
      >
        <translate>Resend</translate>
      </base-button>
      <base-button v-else :disabled="true" css-class="outline minimal tiny">
        <translate>Sent</translate>
      </base-button>
      <base-button
        :disabled="isRemoving"
        css-class="remove-email-btn"
        @click="remove(email.email)"
      >
        <img loading="lazy" src="~/assets/user-account/bin.svg" class="icon" />
      </base-button>
    </div>
  </div>
  <div v-for="email of verifiedEmails" :key="email.email" class="row">
    <span class="email">{{ email.email }}</span>
    <base-button
      :disabled="isRemoving"
      css-class="remove-email-btn"
      @click="remove(email.email)"
    >
      <img class="icon" src="@/assets/images/bin.svg" />
    </base-button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { UserEmail } from '../UserPendingEmailConfirmationsRepositoryFetch'

@Component({
  emits: ['resend', 'remove'],
})
class ChangeEmailPendingEmails extends Vue {
  @Prop()
  verifiedEmails: UserEmail[] = []

  @Prop()
  unverifiedEmails: UserEmail[] = []

  @Prop()
  isRemoving: boolean

  @Prop()
  isFetching: boolean

  remove(email: string) {
    this.$emit('remove', email)
  }
}

export default toNative(ChangeEmailPendingEmails)
</script>

<style scoped>
.unverified-emails {
  margin: 0.5em 0 0 0;
  border-top: 1px solid var(--colour-table-borders);
  padding: 0.5em 0 0;
  /* background: white;
  box-shadow: 0 0 0 25px #fff;
  border-radius: 0 0 .1em .1em;
  z-index: 1;
  position: relative; */
}

p,
.email {
  font-size: var(--body);
}

.row {
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  border-top: 1px solid var(--colour-table-borders);
  padding: 0.25em 0 0 0;
  margin: 0.25em 0 0;
  gap: 0.5em;
}

.remove-email-btn {
  border: none;
  box-shadow: none;
  justify-self: flex-end;
  margin-left: auto;
}

.remove-email-btn .icon {
  width: 0.85em;
  margin: auto;
}

.remove-email-btn:active {
  background: transparent;
}

.remove-email-btn:active .icon {
  opacity: 1;
}
</style>
